import type { IconData } from '@stacksjs/iconify-core'

export const contentRemoveFile: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h8l4 4v2.5A5.5 5.5 0 0 0 6.875 14H0z\"/><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8.692 9.75a4 4 0 1 1-.19 4.192l-.002-.004A4 4 0 0 1 8 12a4 4 0 0 1 .692-2.25M10 11.25v1.5h4v-1.5z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentRemoveFile
